<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none">
      <path
        fill="inherit"
        stroke="none"
        d="M14.67 28h-1.34l1.34-9.33H10c-1.17 0-.44-1-.41-1.04 1.72-3.04 4.3-7.58 7.76-13.63h1.33l-1.33 9.33h4.68c.53 0 .82.26.53.88L14.66 28Z"
      />
    </svg>
  </span>
</template>
